module.exports = __webpack_public_path__ + "static/White Tufflge Avocado.61d0fc20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/hero/White Tufflge Avocado.jpg
// module id = 1043
// module chunks = 213534597649335